import { Popover, Stack, Text } from "@mantine/core"
import { useClickOutside, useWindowScroll } from "@mantine/hooks"
import { Button } from "@tfg/ui"
import React, { useCallback, useEffect } from "react"
import { Trans, useTranslation } from "react-i18next"

import { ActivityDisplay } from "~/pages/SupplierPortal/TraceabilityRequests/Modals/BatchModal/BatchModal.tsx"
import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/TraceabilityOperationsContext"

interface Props {
  target: React.ReactNode
  onClick: () => void
  opened: boolean
  close: () => void
  type: string
  displayActivityId?: string
}

export const BatchPopover = ({
  target,
  onClick,
  opened,
  close,
  type,
  displayActivityId,
}: Props) => {
  const ref = useClickOutside(() => close())
  const { t } = useTranslation(["traceability"])
  const { operationItem } = useTraceabilityOperations()
  const [scroll] = useWindowScroll()

  const handleScroll = useCallback(() => {
    close()
  }, [close])

  useEffect(() => {
    handleScroll()
  }, [handleScroll, scroll])

  return (
    <Popover
      width={200}
      opened={opened}
      withArrow
      position="top"
      offset={0}
      arrowOffset={0}
    >
      <Popover.Target>{target}</Popover.Target>
      <Popover.Dropdown>
        <Stack ref={ref}>
          <Text size="xs">
            <Trans
              t={t}
              i18nKey="traceability:batchPopover.text"
              values={{ key: type }}
              components={
                {
                  activity: (
                    <ActivityDisplay
                      activityId={displayActivityId ?? operationItem.activityId}
                    />
                  ),
                  b: <b />,
                } as const
              }
            />
          </Text>
          <Button onClick={onClick} size="xs">
            {t("traceability:batchPopover.button")}
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  )
}
